import { z } from "zod";
/**
 * Painel da plataforma — o que só os donos do produto fazem: criar empresas
 * para clientes, entrar nelas para suporte e suspender.
 */
/** Verticais que uma empresa nova pode receber, com o rótulo da tela. */
export const VERTICAL_OPTIONS = [
    { value: "aesthetics", label: "Clínica de estética" },
    { value: "infoproduto", label: "Infoproduto" },
    { value: "generic", label: "Genérico" },
];
export const verticalSchema = z.enum(["aesthetics", "infoproduto", "generic"]);
export const createPlatformTenantSchema = z
    .object({
    name: z.string().trim().min(2, "Dê um nome à empresa").max(120),
    vertical: verticalSchema,
    /** Dono da empresa. Já tem conta: vira admin na hora. Não tem: recebe convite. */
    ownerEmail: z.string().trim().email("E-mail inválido").max(200).nullish(),
    /** O dono da plataforma também vira admin da empresa criada. */
    includeMe: z.boolean().default(false),
})
    .refine((v) => Boolean(v.ownerEmail) || v.includeMe, {
    message: "Informe o e-mail do dono ou marque para se incluir como administrador",
    path: ["ownerEmail"],
});
export const platformReasonSchema = z.object({
    reason: z.string().trim().max(500).nullish(),
});
//# sourceMappingURL=platform.js.map